import api from './api';

export const getClosureRecord = async (projectId) => {
  const response = await api.get(`/closure-records/project/${projectId}`);
  return response.data;
};

export const createClosureRecord = async (projectId) => {
  const response = await api.post(`/closure-records/project/${projectId}`);
  return response.data;
};

export const updateClosureRecord = async (closureId, updateData) => {
  const response = await api.patch(`/closure-records/${closureId}`, updateData);
  return response.data;
};
